import { Component, ElementRef, EventEmitter, inject, Inject, Input, Optional, Output, QueryList, ViewChildren, OnInit, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AddOtherDialogComponent } from '../add-other-dialog/add-other-dialog.component';
import {
  formMetaData,
  CodeField, CodeableConceptField, IndividualField, IndividualReferenceField, GroupField,
  codingDataType, ReferenceDataType, ReferenceFieldArray,
  SingleCodeField,
  codeableConceptDataType,
  CodeableConceptFieldFromBackEnd,
} from '../dynamic-forms.interface2';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCard, MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatInputModule } from '@angular/material/input';
import { BehaviorSubject, catchError, combineLatest, debounce, debounceTime, fromEvent, map, merge, filter, Observable, of, pairwise, startWith, tap, withLatestFrom } from 'rxjs';
import { AsyncPipe, CommonModule, JsonPipe, TitleCasePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { formFields } from '../dynamic-forms.interface';
import { MatButtonModule } from '@angular/material/button';
import { SplitHashPipe } from '../split-hash.pipe';
import { HttpClient, HttpContext } from '@angular/common/http';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggle, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio'
import flatpickr from "flatpickr"
import { StretchDirective } from '../../stretch.directive';
import { UploadUiComponent } from '../../upload-ui/upload-ui.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { backendEndPointToken } from '../../app.config';
import { NotificationService } from '../notification/notification.service';
import { InfoDialogService } from '../info-dialog/info-dialog.service';
import { DetailBaseComponent } from '../detail-base/detail-base.component';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ErrorService } from '../error.service';
import { WhoicdtokenService } from '../../whoicdtoken.service';
import { DisableCountParam, DisableSortParam, LoadingUIEnabled } from '../../loading.interceptor';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { ReferenceIdentifierPipe } from '../reference-identifier.pipe';
type FormFields = IndividualField | ReferenceFieldArray | CodeableConceptField | CodeField | IndividualReferenceField | GroupField;

@Component({
  selector: 'app-dynamic-forms-v2',
  host: {
    class: "app-dynamic-forms-v2"
  },
  imports: [MatCardModule, ReactiveFormsModule, MatCheckboxModule, MatSlideToggleModule,
    SplitHashPipe, MatDatepickerModule, MatRadioModule, CommonModule, MatMenuModule,
    MatTimepickerModule,
    MatFormFieldModule, MatSelectModule, MatAutocompleteModule, MatInputModule, AsyncPipe, StretchDirective, UploadUiComponent,
    TitleCasePipe, MatIconModule, JsonPipe, MatTooltipModule, DetailBaseComponent
    , MatButtonModule, ReferenceIdentifierPipe],

  templateUrl: './dynamic-forms-v2.component.html',
  providers: [provideNativeDateAdapter()],
  styleUrl: './dynamic-forms-v2.component.scss'
})
export class DynamicFormsV2Component implements OnInit, AfterViewInit {
  whoIcdtokenService = inject(WhoicdtokenService);
  private hostEl = inject(ElementRef);

  getHostHtml() { return this.hostEl.nativeElement; }
  tokenFromIdc11 = "";
  // Define the formMetaData and formFields as inputs 
  @Input() formMetaData?: formMetaData;
  searchableObject: any = {}
  realHourScroll: any[] = [];
  @Input() formFields!: FormFields[];
  @Input() resetOnSubmit: boolean = true;
  private pendingPrepopulatedData: any;

  private _prepopulatedData: any;
  @Input()
  set prepopulatedData(value: any) {
    this._prepopulatedData = value;
    if (value !== undefined) {
      this.pendingPrepopulatedData = value;
      if (this.aForm) {
        this.applyPrepopulatedData(this.pendingPrepopulatedData);
      }
    }
  }
  get prepopulatedData(): any {
    return this._prepopulatedData;
  }
  @Input() customValidators?: Record<string, any>;
  @Output() onEveryChange = new EventEmitter<any>();
  fb = inject(FormBuilder);
  fieldAutoCompleteObject: { [key: string]: Observable<any> | undefined } = {};
  // Holds latest backend-loaded options per field to enable client-side filtering
  backendOptions: { [key: string]: BehaviorSubject<any[]> } = {};
  aForm!: FormGroup;
  minutes: any[] = [];
  @Output() formSubmitted = new EventEmitter<any>(); // Emits full form value when closeAndReturn() is called
  @Output() ready = new EventEmitter<void>();

  // Inject dialog dependencies
  data = inject(MAT_DIALOG_DATA, { optional: true });
  dialogRef = inject(MatDialogRef<DynamicFormsV2Component>, { optional: true });
  matDialog = inject(MatDialog);
  notif = inject(NotificationService);
  infoServ = inject(InfoDialogService);
  @Output() formCancelled = new EventEmitter<void>();

  backendEndPoint = inject(backendEndPointToken);

  constructor() {
    if (this.data) {
      // console.log(this.data);
      this.formMetaData = this.data.formMetaData;
      this.formFields = this.data.formFields;
      // console.log("data", this.data);
      console.log('📥 Dialog data received:', {
        formMetaData: this.formMetaData,
        formFields: this.formFields?.length,
        hasPrepopulatedData: !!this.data.prepopulatedData
      });
      if (this.data.prepopulatedData) {
        this.pendingPrepopulatedData = this.data.prepopulatedData;
      }
    }

  }
  closeDialog(): void {
    this.formCancelled.emit();

    if (this.dialogRef) {
      this.dialogRef.close({ cancelled: true });
    }
  }
  getGroupFieldKeys(field: FormFields): string[] {
    return Object.keys((field as GroupField).groupFields);
  }

  getGroupField(field: FormFields): GroupField {
    return field as GroupField
  }
  ngOnChanges() {
    if (this.formMetaData && this.formFields) {
      // this.formMetaData = this.data.formMetaData;
      // this.formFields = this.data.formFields;
      // console.log("data", this.data);
    }
    // console.log("Form Metadata:", this.formMetaData);
    // console.log("Form Fields:", this.formFields);

    // if (this.formFields && this.formMetaData) {
    if (this.formFields && this.aForm) {
      this.formFields.sort((a: FormFields, b: FormFields): number => {
        if (a.generalProperties.isArray && (!b.generalProperties.isGroup && !b.generalProperties.isArray && b.generalProperties.inputType !== 'textarea')) {
          return 1
        } else if (b.generalProperties.isArray && (!a.generalProperties.isGroup && !a.generalProperties.isArray && a.generalProperties.inputType !== 'textarea')) {
          return -1
        } else {
          return 0;
        }
      })
      for (const field of this.formFields) {
        this.addFieldToForm(this.aForm, field as FormFields);
      };
      this.recomputeRequiredFieldLabels();
    }
  }

  get isSubmitDisabled(): boolean {
    return this.aForm?.invalid ?? true;
  }

  get submitButtonTooltip(): string {
    if (!this.isSubmitDisabled) {
      return this.formMetaData?.submitText ? `Click to ${this.formMetaData.submitText?.toLowerCase()}` : 'Submit';
    }
    return this.requiredFieldLabels.length
      ? `Complete required fields: ${this.requiredFieldLabels.join(', ')}`
      : 'Complete required fields to enable submit';
  }

  ngOnInit() {
    this.whoIcdtokenService.token$.subscribe(t => {
      this.tokenFromIdc11 = t;
    });
    // Initialization logic if needed
    // console.log('Form Metadata:', this.formMetaData);
    // console.log('Form Fields:', this.formFields);
    this.aForm = this.fb.group({});
    // if (this.formFields && this.formMetaData) {
    if (this.formFields) {
      this.formFields.sort((a: FormFields, b: FormFields): number => {
        if (a.generalProperties.isArray && (!b.generalProperties.isGroup && !b.generalProperties.isArray && b.generalProperties.inputType !== 'textarea')) {
          return 1
        } else if (b.generalProperties.isArray && (!a.generalProperties.isGroup && !a.generalProperties.isArray && a.generalProperties.inputType !== 'textarea')) {
          return -1
        } else {
          return 0;
        }
      })
      for (const field of this.formFields) {
        this.addFieldToForm(this.aForm, field as FormFields);
      };

      if (this.pendingPrepopulatedData) {
        this.applyPrepopulatedData(this.pendingPrepopulatedData);
      }
      this.recomputeRequiredFieldLabels();
    }
    for (let m = 0; m < 61; m++) {
      this.minutes.push(m < 10 ? '0' + m : m);
    }


    this.aForm.valueChanges.subscribe(value => {
      this.onEveryChange.emit(value);
    });
  }
  /**
   * Apply prepopulated data to the form
   * Handles both simple fields and nested group fields
   */
  private applyPrepopulatedData(data: any): void {
    if (!data || !this.aForm) {
      return;
    }

    console.log('🔧 Applying prepopulated data:', data);

    Object.keys(data).forEach(key => {
      const control = this.aForm.get(key);
      if (control) {
        const value = data[key];

        // Handle array fields
        if (Array.isArray(value)) {
          const formArray = control as FormArray;

          // Clear existing controls
          while (formArray.length > 0) {
            formArray.removeAt(0);
          }

          // Add controls with values
          value.forEach((item: any) => {
            if (typeof item === 'object' && item !== null) {
              // Group field in array
              const group = this.fb.group({});
              Object.keys(item).forEach(subKey => {
                group.addControl(subKey, this.fb.control(item[subKey]));
              });
              formArray.push(group);
            } else {
              // Simple value in array
              formArray.push(this.fb.control(item));
            }
          });
        }
        // Handle group fields (objects)
        else if (typeof value === 'object' && value !== null) {
          Object.keys(value).forEach(subKey => {
            const subControl = control.get(subKey);
            if (subControl) {
              subControl.setValue(value[subKey], { emitEvent: false });
            }
          });
        }
        // Handle simple fields
        else {
          control.setValue(value, { emitEvent: false });
        }

        console.log(`✅ Set ${key}:`, control.value);
      } else {
        console.warn(`⚠️ Control not found for key: ${key}`);
      }
    });

    // Mark form as pristine after prepopulation
    this.aForm.markAsPristine();
    console.log('✅ Prepopulated data applied successfully');
    this.pendingPrepopulatedData = undefined;
  }
  addFieldToForm(fG: FormGroup, field: FormFields, nodo = false, leaveDependencyId = false) {
// $#$    // /* alert(leaveDependencyId); */
    if (field.generalProperties.isGroup && field.hasOwnProperty('groupFields')
      && !field.generalProperties.isArray
    ) {

      let control = this.fb.group({});

      for (const key in (field as GroupField).groupFields) {
        field = field as GroupField
        if (field.groupFields.hasOwnProperty(key)) {
          const element = field.groupFields[key];
          this.addFieldToForm(control, element as FormFields);
        }

      }
      fG.addControl(field.generalProperties.fieldApiName, control)


    } else if (field.generalProperties.isArray &&
      field.generalProperties.isGroup && field.hasOwnProperty('groupFields')
    ) {

      let control: FormGroup = this.fb.group({});
      for (const key in (field as GroupField).groupFields) {
        field = field as GroupField
        if (field.groupFields.hasOwnProperty(key)) {
          const element = field.groupFields[key];
          //  control.addControl(element.generalProperties.fieldApiName, element)
          this.addFieldToForm(control, element as FormFields);
        }

      }

      let superControl = this.fb.array([control])

      fG.addControl(field.generalProperties.fieldApiName, superControl)
      // console.log(fG.value);

    }
    // else if (field.generalProperties.isArray &&
    //   (!field.generalProperties.isGroup || !field.hasOwnProperty('groupFields'))
    // ) {

    //  let control = this.fb.control("");

    //   for (const key in (field as GroupField).groupFields) {
    //     field = field as GroupField
    //     if (field.groupFields.hasOwnProperty(key)) {
    //       const element = field.groupFields[key];
    //       this.addFieldToForm(control, element as FormFields);
    //     }

    //   }
    //   fG.addControl(field.generalProperties.fieldApiName, control)

    // }
    else {

      let control = this.fb.control('');
      let searchableObject: any[] = [];
      // if (Array.isArray(field.data)) {
      //   searchableObject = field.data;



      if (field.generalProperties.fieldType == "IndividualReferenceField"
        || field.generalProperties.fieldType == "SingleCodeField"
        || field.generalProperties.fieldType == 'CodeableConceptField' || field.generalProperties.fieldType == "CodeField"
        || field.generalProperties.fieldType == 'CodeableConceptFieldFromBackEnd'
      ) {

        switch (field.generalProperties.fieldType) {
          case "IndividualReferenceField":
// $#$            // /* alert(JSON.stringify(field.data) */);
            searchableObject = (field as IndividualReferenceField).data || [];
            break;
          case "CodeableConceptField":
// $#$            //   /* alert(field.generalProperties.fieldType); */

            searchableObject = ((field as CodeableConceptField).data as codeableConceptDataType)?.coding || (field as CodeableConceptField).data || [];
            // console.log("searchable object", searchableObject)
            break;
          case "CodeField":
            searchableObject = (field as CodeField).data || [];
            break;
          case "SingleCodeField":
            searchableObject = (field as SingleCodeField).data || [];
// $#$            // /* alert(searchableObject.join(" ") */)
            break;
          case "CodeableConceptFieldFromBackEnd":
// $#$            // /* alert("hey") */
            searchableObject = (field as CodeableConceptFieldFromBackEnd).data
            break;
          default:
            searchableObject = [];
            break;
        }
        // console.log(searchableObject);
        // Append 'Others' option if allowed and not already present (for non-backend codeable concept fields etc.)
        if (field.generalProperties.allowedOthers
          && field.generalProperties.fieldType !== 'CodeableConceptFieldFromBackEnd'
          && !searchableObject.includes('Others')
        ) {
          searchableObject = [...searchableObject, 'Others'];
        }


      }

      if (field.generalProperties.value) {
        control.setValue(field.generalProperties.value);
      }
      if (field.generalProperties.validations) {
        const validators: any[] = [];
        const asyncValidators: any[] = [];
        field.generalProperties.validations.forEach((validation: any) => {
          if (validation.type === 'default') {
            if (validation.isFunction) {
              validators.push((Validators as any)[validation.name](...validation.functionArgs || []));
            } else {
              validators.push((Validators as any)[validation.name]);
            }
          } else if (validation.type === 'custom' && this.customValidators?.[validation.name]) {
            const customVal = this.customValidators[validation.name];
            // Check if it's an async validator (returns Observable or Promise)
            // This is a bit of a heuristic but works for our registry
            asyncValidators.push(customVal);
          }
        });
        if (validators.length > 0) {
          control.setValidators(validators);
        }
        if (asyncValidators.length > 0) {
          control.setAsyncValidators(asyncValidators);
        }
      }
      if (field.generalProperties.isArray) {
        fG.addControl(field.generalProperties.fieldApiName, this.fb.array([control]));
      } else {
        // console.log(fG, field.generalProperties.fieldApiName)
        fG.addControl(field.generalProperties.fieldApiName, control);
      }

      this.searchableObject[field.generalProperties.fieldApiName] = searchableObject
      // if (field.generalProperties.isArray) {
      //   // at most 10 entries for array fields
      //   for (let i = 1; i < 10; i++) {
      //     const arInd = `${field.generalProperties.fieldApiName}-${i}`;
      //     this.searchableObject[arInd] = searchableObject
      //   }
      // }
      // console.log(this.searchableObject, "this.searcheableobject")
      if (field.generalProperties.fieldType == "CodeableConceptFieldFromBackEnd") {
        if (!nodo) {
          // Prepare a subject to cache backend results and filter locally as user types
          const api = field.generalProperties.fieldApiName;
          if (!this.backendOptions[api]) {
            this.backendOptions[api] = new BehaviorSubject<any[]>([]);
          }
          const ctrl = fG.get(api) as FormControl;
          this.fieldAutoCompleteObject[api] = combineLatest([
            ctrl.valueChanges.pipe(startWith("")),
            this.backendOptions[api].asObservable()
          ]).pipe(
            map(([f, options]) => {
              console.log('Filtering options for', api, 'with term', f, options, ctrl.value, control.value);
              if (!f) { f = ""; }
              const term = String(f).toLowerCase();
              return (options || []).filter((g: any) => {
                if (typeof g === "object") {
                  const keys = Object.keys(g);
                  return keys.some((key) => String(g[key]).toLowerCase().includes(term));
                }
                return String(g).toLowerCase().includes(term);
              });
            })
          );
        }
      } else {
        //grup frm in
        if (!nodo) {
          this.fieldAutoCompleteObject[field.generalProperties.fieldApiName] =
            // combineLatest([,


            control.valueChanges.pipe(startWith(""), tap((t: any) => { }),
              withLatestFrom(this.allInputsCurrentEvent.pipe(tap(t => { })))
            )
              .pipe(
                startWith(['', {} as any]),
                pairwise(),
                map(([prevV, currV]) => {

// $#$                  // /* alert(JSON.stringify(currV[0]) */);
                  let f: any = currV[0];
                  if (!f) {
                    f = ""
                  }
                  // if (field.generalProperties.controllingField && field.generalProperties.controllingField.isAControlField) {
                  //   if (f === field.generalProperties.controllingField.dependentFieldVisibilityTriggerValue) {
                  //     (document.querySelector(`[dependency-id = "${field.generalProperties.controllingField.controlledFieldDependencyId}"]`) as HTMLElement).classList.remove('d-none')
                  //   } else {
                  //     if (!(document.querySelector(`[dependency-id = "${field.generalProperties.controllingField.controlledFieldDependencyId}"]`) as HTMLElement)?.classList?.contains('d-none')) {
                  //       (document.querySelector(`[dependency-id = "${field.generalProperties.controllingField.controlledFieldDependencyId}"]`) as HTMLElement)?.classList.add('d-none');
                  //     }
                  //   }
                  // }
                  // console.log(field.generalProperties)
                  if (field.generalProperties.controllingField && field.generalProperties.controllingField.length > 0) {
                    for (const cField of field.generalProperties?.controllingField) {
                      // first hide all controlled fields
// $#$                      // /* alert(f + " " + field.generalProperties.fieldApiName); */
// $#$                      // /* alert(leaveDependencyId); */
                      // if (!leaveDependencyId) {

                      //is the element matching the control field attribute more tha one
                      let count = Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`)).length;
                      // if (count > 1) {
                      // get all controlled and controlling fields
                      let controlledFields = Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`));
                      let controllingFields = Array.from(document.querySelectorAll(`[controlledFieldsIdentifier *= "${this.joinAPropInEachObjectElementOfAnArray(field.generalProperties.controllingField, 'controlledFieldDependencyId', ' ')}"]`)).filter(
                        (el: Element) => el.getAttribute('controlledFieldsIdentifier')?.includes(cField.controlledFieldDependencyId!)
                      );
                      console.log(controllingFields, controlledFields);
                      //iterate to use the indexx
                      controlledFields.forEach((cf: any, index) => {
// $#$                        // /* alert(controllingFields[index].getElementsByTagName('select') */?.[0]?.value);
                        let fHere;
                        if (controllingFields.length === 1) {
                          fHere = controllingFields[0].getElementsByTagName('input')?.[0]?.value ||
                            controllingFields[0].getElementsByTagName('select')?.[0]?.value;
                        } else if (controlledFields.length > controllingFields.length) {
                          let determinant = Math.ceil((index + 1) / (controlledFields.length / controllingFields.length));
// $#$                          // /* alert(determinant); */
                          fHere = controllingFields[determinant - 1].getElementsByTagName('input')?.[0]?.value ||
                            controllingFields[determinant - 1].getElementsByTagName('select')?.[0]?.value;


                        } else {
                          let ControlledFieldsSections = controlledFields.length / controllingFields.length;
// $#$                          // /* alert(ControlledFieldsSections); */
                          let determinant = Math.ceil(index + 1 / ControlledFieldsSections);
// $#$                          // /* alert(determinant); */

                          fHere = controllingFields[index].getElementsByTagName('input')?.[0]?.value ||
                            controllingFields[index].getElementsByTagName('select')?.[0]?.value;

                        }
                        console.log(fHere);
                        // console.log(Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[index],
                        //   Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[index]);


                        (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[index] as HTMLElement)?.classList.add('d-none');
                        if (fHere === cField.dependentFieldVisibilityTriggerValue) {
                          // /* alert
                          (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[index] as HTMLElement)?.classList.remove('d-none');
                          (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[index] as HTMLElement).style.width = '100%';
                        } else {

                        }

                      }
                      )
                      // } else {

                      //   (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[0] as HTMLElement)?.classList.add('d-none');

                      //   // then show the controlled field if the value matches the trigger value

                      //   if (f === cField.dependentFieldVisibilityTriggerValue) {
                      //     (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[0] as HTMLElement)?.classList.remove('d-none');
                      //     (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[0] as HTMLElement).style.width = '100%';
                      //   }
                      // }

                    }
                  }
                  // console.log(f, field.generalProperties.fieldApiName);
                  if (!this.fieldsCompleteData[`${field.generalProperties.fieldApiName}`]) {
                    this.fieldsCompleteData[`${field.generalProperties.fieldApiName}`] = searchableObject;
                  }

                  // f = typeof(f) === "string" ? f.toLowerCase() : f.display?.toLowerCase();
// $#$                  // /* alert(f); */
// $#$                  // /* alert(currEv[field.generalProperties.fieldApiName]); */
                  // console.log(prevV, currV);
// $#$                  // /* alert(currV[1][field.generalProperties.fieldApiName]) */
                  // console.log(control.value);
                  if (currV[1] && currV[1][field.generalProperties.fieldApiName] == 'blur'
                    // && currV[1][field.generalProperties.fieldApiName] !== prevV[1][field.generalProperties.fieldApiName]
                  ) {

                    return searchableObject
                  }
                  // if(currV[1] === prevV[1] && currV[0][field.generalProperties.fieldApiName] == 'mouseleave'){
                  //   console.log(currV[0]+" "+prevV[0]);
                  //    return searchableObject
                  // }
                  return searchableObject.filter((g: any) => {

                    if (f) {
// $#$                      // /* alert(typeof (f) */);
                    }
                    if (typeof (g) == "object" &&
                      typeof (f) == "string"
                    ) {
                      f = f.toLowerCase();
                      const keys = Object.keys(g);

                      return keys.some((key) => {

                        return g[key].toLowerCase().includes(f);
                      })
                    } else if (typeof (g) == "object" &&
                      typeof (f) == "object"
                    ) {
                      const keys = Object.keys(g);
                      return keys.some((key) => {
                        if (Object.keys(f).includes('display')) {
                          // console.log(g[key])
                          return g[key].toLowerCase().includes(f.display.toLowerCase());
                        } else {
                          return false;
                        }
                      })
                    } else {

                      return g.toLowerCase().includes(f)
                    }
                  })

                }))
        }
      }

      // Listen for selection of 'Others' to open custom value dialog
      if (field.generalProperties.allowedOthers) {
        control.valueChanges.subscribe((val: any) => {
          if (val === 'Others') {
            this.openAddOtherValueDialog(field.generalProperties.fieldApiName, control, field);
          }
        });
      }

    }
    //  console.log((this.fieldAutoCompleteObject));

  }

  getErrorMessage(controlName: string, field: FormFields, groupName?: string, index?: number): string {
    let control: any;
    if (groupName !== undefined && index !== undefined) {
      const array = this.aForm.get(groupName) as FormArray;
      control = array.at(index).get(controlName);
    } else if (index !== undefined) {
      const array = this.aForm.get(controlName) as FormArray;
      control = array.at(index);
    } else {
      control = this.aForm.get(controlName);
    }

    if (!control || !control.errors) return '';

    if (control.errors['required']) return 'This field is required';
    if (control.errors['email']) return 'Invalid email address';
    if (control.errors['duplicateEmail']) return 'Email already registered';
    if (control.errors['duplicateNin']) return 'NIN already registered';

    return field.generalProperties.fieldErrorHint || 'Invalid value';
  }

  http = inject(HttpClient);
  // infoServ = inject(InfoDialogService);
  searchCodeableConceptFromBackEnd(fieldApiName: string, value: string, indexii: number = 0) {
    const trimmedValue = (value ?? '').trim();
    if (!trimmedValue || trimmedValue.toLowerCase() === 'undefined') {
      return;
    }

    const rawUrl = this.searchableObject[fieldApiName];
    const baseUrl = Array.isArray(rawUrl) ? rawUrl[0] : rawUrl;

    if (typeof baseUrl !== 'string' || !baseUrl.length) {
      console.warn('CodeableConceptFieldFromBackEnd is missing a search URL for field:', fieldApiName, rawUrl);
      return;
    }

    // Deep search for the field definition (including nested group fields)
    const findFieldDefinition = (fields: FormFields[], apiName: string): FormFields | null => {
      for (const field of fields) {
        if (field.generalProperties.fieldApiName === apiName) {
          return field;
        }
        if (field.generalProperties.isGroup && 'groupFields' in field) {
          const groupField = field as GroupField;
          for (const key in groupField.groupFields) {
            const subField = groupField.groupFields[key];
            if (subField.generalProperties.fieldApiName === apiName) {
              return subField;
            }
            // Recursively search nested groups
            if (subField.generalProperties.isGroup && 'groupFields' in subField) {
              const nestedResult = findFieldDefinition([subField], apiName);
              if (nestedResult) return nestedResult;
            }
          }
        }
      }
      return null;
    };

    const fieldDef = findFieldDefinition(this.formFields || [], fieldApiName);
    const allowOthers = !!fieldDef?.generalProperties?.allowedOthers;
    const allowText = !!fieldDef?.generalProperties?.allowTextForCodeableConcept;
    const control = this.aForm.get(fieldApiName) as FormControl | null;

    const handleEmptyResults = () => {
      if (!allowOthers) {
        return [];
      }
      if (allowText && allowOthers) {
        this.infoServ.show('No options returned from the server. You can leave the search term as is, edit it, or refine your search.', { title: 'Select Options', duration: 4000 });
        return [];
      }
      this.infoServ.show('No options returned from the server. You can leave a custom value by selecting "Others".', { title: 'Select Options', duration: 4000 });
      if (control && control.value !== 'Others') {
        control.setValue('');
      }
      return ['Others'];
    };

    // Check if URL is RxNorm based - updated to match actual RxNorm endpoint
    const isRxNorm = baseUrl.includes('rxnav.nlm.nih.gov');
    const isWhoIcd = baseUrl.includes('icd');
    const separator = baseUrl.includes('?') ? '&' : '?';
    const encodedTerm = encodeURIComponent(trimmedValue);
    const searchUrl = isRxNorm ? `${baseUrl}${separator}name=${encodedTerm}` : isWhoIcd ? `${baseUrl}${separator}q=${encodedTerm}` : `${baseUrl}${separator}filter=${encodedTerm}`;
// $#$    // /* alert(fieldApiName) */
    this.http.get(searchUrl, {
      ...(fieldApiName === 'reasonCode' ? {
        context: new HttpContext().set(DisableCountParam, true).
          set(DisableSortParam, true),
      } : {}),


      ...(fieldApiName === 'reasonCode' ? {
        headers: { 'Authorization': `Bearer ${this.tokenFromIdc11}` }
      } : {})
    }).pipe(
      map((data: any) => {
        let base: any[] = [];

        if (isRxNorm && this.isRxNormResponse(data)) {
          // Handle RxNorm drugGroup response
          base = this.transformRxNormToValueSet(data, baseUrl);
        } else if (isWhoIcd) {
          return data
        } else {
          // Handle standard FHIR ValueSet response
          base = (data?.expansion?.contains || []).map((item: any) =>
            `${item.code}$#$${item.display}$#$${item.system}`
          );
        }

        // NEW: field-specific mapping (reasonCode expects WHO ICD-11 objects)
        base = this.mapBackendConceptOptionsForField(fieldApiName, base, data, baseUrl);

        // De-duplicate results within a single backend response
        const deduped = Array.from(new Set(base));
        if (!deduped.length) {
          return handleEmptyResults();
        }

        return allowOthers && !deduped.includes('Others') ? [...deduped, 'Others'] : deduped;
      }),
      catchError((err) => {
        console.error('Error fetching codeable concept options from backend:', err);
        this.infoServ.show(`Failed to load options from backend.
      ${allowOthers ? "You can, instead, select \"Others\" from the dropdown and then enter the value" : ""}`, { title: 'Select Options', duration: 4000 });
        if (allowOthers && control && control.value !== 'Others') {
          control.setValue('Others');
        }
        return of(allowOthers ? ['Others'] : []);
      })
    ).subscribe((options: any[]) => {
      // Merge with existing cached options and de-duplicate to avoid clearing the list
      let indexToUse = indexii > 0 ? `${fieldApiName}-${indexii}` : fieldApiName
      const current = this.backendOptions[indexToUse]?.getValue?.() || [];
      const merged = Array.from(new Set([...(current || []), ...(options || [])]));

      if (!this.backendOptions[indexToUse]) {
        this.backendOptions[indexToUse] = new BehaviorSubject<any[]>(merged);
      } else {
        console.log(indexToUse, merged);
        this.backendOptions[indexToUse].next(merged);
      }
    });
  }

  /**
   * Field-specific backend option mapping.
   * - For `reasonCode`: WHO ICD-11 search results should be represented as objects:
   *   { code: string; display: string; system: string } (NOT "$#$" string)
   * - For other fields: keep existing behavior.
   *
   * NOTE: In your WHO ICD-11 flow, `searchUrl` returns objects like:
   *   { destinationEntities: [{ theCode?, code?, title? ... }] } (see AddMedicineRequestsComponent).
   */
  private mapBackendConceptOptionsForField(
    fieldApiName: string,
    base: any[],
    rawResponse: any,
    baseUrl: string
  ): any[] {
    if (fieldApiName !== 'reasonCode') return base;

    // WHO ICD-11 search normalisation (matches your AddMedicineRequestsComponent logic)
    const entities = rawResponse//?.destinationEntities ?? rawResponse?.entities ?? rawResponse?.results ?? [];
    const rows = Array.isArray(entities) ? entities : [];

    const system = 'https://id.who.int/icd/release/11/2025-01/mms';

    return rows
    // .map((e: any) => {
    //   const code =
    //     e?.theCode ??
    //     e?.code ??
    //     e?.id ??
    //     e?.['@id'] ??
    //     e?.stemId ??
    //     '';

    //   const display =
    //     e?.title?.['@value'] ??
    //     e?.title ??
    //     e?.matchingText ??
    //     String(code || '').trim();

    //   if (!code && !display) return null;

    //   return {
    //     code: String(code).trim(),
    //     display: String(display).trim(),
    //     system
    //   };
    // })
    // .filter((x: any) => !!x);
  }

  private isRxNormResponse(data: any): boolean {
    const conceptGroups = data?.drugGroup?.conceptGroup;
    if (!conceptGroups) {
      return false;
    }
    const groups = Array.isArray(conceptGroups) ? conceptGroups : [conceptGroups];
    return groups.some((group: any) => Array.isArray(group?.conceptProperties) && group.conceptProperties.length > 0);
  }

  private transformRxNormToValueSet(data: any, url: string): (string | { code: string; display: string; system: string })[] {
    const results: string[] = [];
    const ingredientNames = new Set<string>();

    // Extract type filter from URL if present
    const typeMatch = url.match(/type=([^&]+)/i);
    const purposeMatch = url.match(/purpose=([^&]+)/i);
    const purposeFilter = purposeMatch ? purposeMatch[1].toUpperCase() : null;
    const filterType = typeMatch ? typeMatch[1].toUpperCase() : null;
// $#$    // /* alert(JSON.stringify(filterType) */)
    const conceptGroups = data?.drugGroup?.conceptGroup;
    if (!conceptGroups) {

      return results;
    }

    const groups = Array.isArray(conceptGroups) ? conceptGroups : [conceptGroups];
    groups.forEach((group: any) => {
      const tty = group?.tty?.toUpperCase();
      if (filterType && tty !== filterType) {
        return;
      }

      const properties = Array.isArray(group?.conceptProperties) ? group.conceptProperties : [];
      properties.forEach((concept: any) => {
        const code = concept?.rxcui;
        const rawDisplay = (concept?.name ?? '').trim();
        if (!rawDisplay) {
          return;
        }
        if (purposeFilter === 'INGREDIENT') {
          rawDisplay.split('/').map((part: string) => part.trim()).filter((part: string) => part.length).forEach((name: string) => {
            ingredientNames.add(name);
          });
          return;
        }
        const display = this.withBrandFirst(rawDisplay);
        if (!code || !display) {
          return;
        }
        const system = 'http://www.nlm.nih.gov/research/umls/rxnorm';
        const fullText = rawDisplay;
        // Append the original RxNorm term (after the third delimiter) so filtering
        // can still match against strength/dose text that was trimmed from display.
        results.push(`${code}$#$${display}$#$${system}`);
      });
    });
    console.log(results)
    if (purposeFilter === 'INGREDIENT' && ingredientNames.size) {
      const baseSystem = `${this.backendEndPoint}`;
      return Array.from(ingredientNames).map(name => ({
        code: name,
        display: name,
        system: baseSystem
      })).map(item => `${item.code}$#$${item.display}$#$${item.system}`);

    }
    return results;
  }
  // Open Material dialog to collect a custom value when 'Others' is chosen
  openAddOtherValueDialog(fieldApiName: string, control: FormControl, field: FormFields) {
    const name = field.generalProperties.fieldLabel || field.generalProperties.fieldName;
    const dialogRef = this.matDialog.open(AddOtherDialogComponent, {
      width: '420px',
      data: { fieldName: name }
    });
    dialogRef.afterClosed().subscribe((result: string | undefined) => {
      if (result && typeof result === 'string' && result.trim() !== '') {
        const trimmed = result.trim();
        if (field.generalProperties.fieldType === 'CodeableConceptFieldFromBackEnd'
          || field.generalProperties.fieldType === 'CodeableConceptField') {
          const system = this.backendEndPoint;
          control.setValue(`${trimmed}$#$${trimmed}$#$${system}`);
        } else {
          control.setValue(trimmed);
        }


        // control.setValue(`${ trimmed }`);
        const currentList = this.searchableObject[fieldApiName];
        if (Array.isArray(currentList) && !currentList.includes(trimmed)) {
          const withoutOthers = currentList.filter((v: any) => v !== 'Others');
          this.searchableObject[fieldApiName] = [...withoutOthers, trimmed, 'Others'];
        }
      } else {
        // Reset to blank if cancelled or empty
        control.setValue('');
      }
    });
  }
  displayCodeDisplay(codeDisplay: string): string {
    return codeDisplay;
  }



  displayConceptFieldDisplay(conceptField: string | { display?: string } | null | undefined): string {
    if (!conceptField) {
      return '';
    }
    if (typeof conceptField === 'string' && conceptField.includes('$#$')) {
      return conceptField.split('$#$')[1] || '';
    }
    if (typeof conceptField === 'string' && !conceptField.includes('$#$')) {
      return conceptField
    }

    return (conceptField as { display?: string }).display ?? '';
  }

  private withBrandFirst(rawDisplay: string): string {
    const brandMatch = rawDisplay.match(/\s*\[([^\]]+)\]\s*$/);
    if (!brandMatch) {
      return rawDisplay;
    }
    const brand = brandMatch[1].trim();
    const stripped = rawDisplay.replace(/\s*\[[^\]]+\]\s*$/, '').trim();
    if (!stripped) {
      return brand;
    }
    return `${brand} - ${stripped}`;
  }
  getAFormArrayControl(fieldApiName: string): FormArray {
    // console.log(fieldApiName, this.aForm.value);
    // console.log((this.aForm.get(fieldApiName) as FormArray).controls.length)
    return this.aForm.get(fieldApiName) as FormArray;
  }
  addToAFormArray(fieldApiName: string) {
    let control;
    let fieldData = this.formFields.find((f: FormFields) => f.generalProperties.fieldApiName == fieldApiName);
    if (fieldData?.generalProperties.isGroup && fieldData?.hasOwnProperty('groupFields')

    ) {
// $#$      // /* alert("i am group") */
      control = this.fb.group({});
      for (const key in (fieldData as GroupField).groupFields) {
        fieldData = fieldData as GroupField;
        if (fieldData.groupFields.hasOwnProperty(key)) {
          const element = fieldData.groupFields[key];
          let lengthBeforePush = this.getAFormArrayControl(fieldApiName).controls.length;
          if (lengthBeforePush > 1) {
            this.addFieldToForm(control, element as FormFields, true, true);
          } else {
            this.addFieldToForm(control, element as FormFields, true);
          }
          // console.log(this.aForm.value);


        }




      }

      this.getAFormArrayControl(fieldApiName).push(control);
      // Promise.resolve().then(() => {
      //   console.log("Form + controls now stable");

      //   // }

      //   this.shakeControls();


      // });
      const currentControlLength = this.getAFormArrayControl(fieldApiName).controls.length;
      console.log(currentControlLength);
      if (currentControlLength > 1) {

        for (const key in (fieldData as GroupField).groupFields) {

          let searchableObject: any[] = [];
          // if(field.generalProperties.fieldType == "CodeableConceptFieldFromBackEnd"){
          if ((fieldData as GroupField).groupFields[key].generalProperties.fieldType == "CodeableConceptFieldFromBackEnd") {
// $#$            // /* alert("hey") */
            // Prepare a subject to cache backend results and filter locally as user types
            const api = `${(fieldData as GroupField).groupFields[key].generalProperties.fieldApiName}-${currentControlLength - 1}`
            if (!this.backendOptions[api]) {
              this.backendOptions[api] = new BehaviorSubject<any[]>([]);
            }
            // const ctrl = fG.get(api) as FormControl;
            this.fieldAutoCompleteObject[`${(fieldData as GroupField).groupFields[key].generalProperties.fieldApiName}-${currentControlLength - 1}`]
              = combineLatest([
                control?.get([`${(fieldData as GroupField)?.groupFields[key]?.generalProperties?.fieldApiName}`])!.valueChanges.pipe(startWith("")),
                this.backendOptions[api].asObservable()
              ]).pipe(
                map(([f, options]) => {
                  console.log(f, options);
                  if (!f) { f = ""; }
                  const term = String(f).toLowerCase();
                  return (options || []).filter((g: any) => {
                    if (typeof g === "object" && typeof f === "string") {
                      const keys = Object.keys(g);
                      return keys.some((key) => String(g[key]).toLowerCase().includes(term));
                    } else if (typeof g === "object" && typeof f === "object") {
                      const keys = Object.keys(g);
                      return keys.some((key) => {
                        if (Object.keys(f).includes('display')) {
                          return String(g[key]).toLowerCase().includes(f.display.toLowerCase());
                        } else if (Object.keys(f).includes('code')) {
                          return String(g[key]).toLowerCase().includes(f.code.toLowerCase());
                        } else {
                          return false;
                        }
                      });
                    }
                    return String(g).toLowerCase().includes(term);
                  });
                })
              );
            // }

          }
          else {
// $#$            // /* alert("not backend") */
            this.fieldAutoCompleteObject[`${(fieldData as GroupField).groupFields[key].generalProperties.fieldApiName}-${currentControlLength - 1}`] =

              control?.get([`${(fieldData as GroupField)?.groupFields[key]?.generalProperties?.fieldApiName}`])?.valueChanges.pipe(startWith(""), tap(t => console.log(t)),
                withLatestFrom(this.allInputsCurrentEvent), tap(t => console.log(t))
              )
                .pipe(
                  startWith(['', {} as any]),
                  pairwise(),
                  map(([prevV, currV]) => {
// $#$                    // /* alert(JSON.stringify(currV[0]) */);
                    let f: any = currV[0];
                    // control.valueChanges.pipe(startWith(""), map((f: any) => {
// $#$                    // /* alert(`${ (fieldData as GroupField) */.groupFields[key].generalProperties.fieldApiName } -${ currentControlLength - 1 } `)
                    if (typeof (f) === "string") {
                      f = f.toLowerCase();
                    }




                    let field = fieldData as FormFields;

                    if ((fieldData as GroupField).groupFields[key].generalProperties.fieldType == "IndividualReferenceField" ||
                      (fieldData as GroupField).groupFields[key].generalProperties.fieldType == 'CodeableConceptField' ||
                      (fieldData as GroupField).groupFields[key].generalProperties.fieldType == "CodeField"
                      || (fieldData as GroupField).groupFields[key].generalProperties.fieldType == "SingleCodeField"
                    ) {

                      switch ((fieldData as GroupField).groupFields[key].generalProperties.fieldType) {
                        case "IndividualReferenceField":
                          searchableObject = (fieldData as GroupField).groupFields[key].data || [];
                          break;
                        case "CodeableConceptField":
// $#$                          //   /* alert(field.generalProperties.fieldType); */
                          searchableObject = (fieldData as GroupField).groupFields[key].data || [];
                          // console.log("searchable object", searchableObject)
                          break;
                        case "CodeField":
// $#$                          // /* alert(key); */
// $#$                          // /* alert(JSON.stringify((fieldData as GroupField) */.groupFields[key].data));
                          searchableObject = [...((fieldData as GroupField).groupFields[key].data || [])];
                          break;
                        case "SingleCodeField":
// $#$                          // /* alert(key); */
// $#$                          // /* alert(JSON.stringify((fieldData as GroupField) */.groupFields[key].data));
                          searchableObject = [...((fieldData as GroupField).groupFields[key].data || [])];
                          break;

                        default:
                          searchableObject = [];
                          break;
                      }



                    }
                    // console.log(searchableObject, "searchableObject");
                    // if (!this.fieldsCompleteData[`${ fieldApiName } -${ currentControlLength - 1 } `]) {
                    //   this.fieldsCompleteData[`${ fieldApiName } -${ currentControlLength - 1 } `] = searchableObject;
                    // }
                    if ((fieldData as GroupField).groupFields[key].generalProperties.controllingField && ((fieldData as GroupField)?.groupFields?.[key]?.generalProperties?.controllingField?.length || 0) > 0) {
                      for (const cField of ((fieldData as GroupField)?.groupFields?.[key]?.generalProperties?.controllingField) || []) {
                        // first hide all controlled fields
                        let otisumi = (fieldData as GroupField).groupFields[key];
// $#$                        // /* alert(f + " " + field.generalProperties.fieldApiName); */
// $#$                        // /* alert(leaveDependencyId); */
                        // if (!leaveDependencyId) {

                        //is the element matching the control field attribute more tha one
                        let count = Array.from(document.querySelectorAll(`[dependency-id*="${cField.controlledFieldDependencyId}"]`)).length;
                        // if (count > 1) {
                        // get all controlled and controlling fields
                        let controlledFields = Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`));
                        let controllingFields = Array.from(document.querySelectorAll(`[controlledFieldsIdentifier *= "${this.joinAPropInEachObjectElementOfAnArray(otisumi.generalProperties.controllingField, 'controlledFieldDependencyId', ' ')}"]`)).filter(
                          (el: Element) => el.getAttribute('controlledFieldsIdentifier')?.includes(cField.controlledFieldDependencyId!)
                        );
                        console.log(controllingFields, controlledFields);
                        //iterate to use the indexx
                        controlledFields.forEach((cf: any, index) => {
                          let fHere = controllingFields[index].getElementsByTagName('input')[0].value;
                          console.log(index);
                          // console.log(Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[index],
                          //   Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[index]);


                          (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[index] as HTMLElement)?.classList.add('d-none');
                          if (fHere === cField.dependentFieldVisibilityTriggerValue) {
                            // /* alert
                            (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[index] as HTMLElement)?.classList.remove('d-none');
                            (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[index] as HTMLElement).style.width = '100%';
                          } else {

                          }

                        }
                        )
                        // } else {

                        //   (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[0] as HTMLElement)?.classList.add('d-none');

                        //   // then show the controlled field if the value matches the trigger value

                        //   if (f === cField.dependentFieldVisibilityTriggerValue) {
                        //     (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[0] as HTMLElement)?.classList.remove('d-none');
                        //     (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[0] as HTMLElement).style.width = '100%';
                        //   }
                        // }

                      }
                    }
                    console.log(currV[1][`${(fieldData as GroupField).groupFields[key].generalProperties.fieldApiName}-${currentControlLength - 1}`])
                    if (currV[1] && currV[1][`${(fieldData as GroupField).groupFields[key].generalProperties.fieldApiName}-${currentControlLength - 1}`] == 'blur'
                      // && currV[1][`${ (fieldData as GroupField).groupFields[key].generalProperties.fieldApiName } -${ currentControlLength - 1 } `] !== prevV[1][`${ (fieldData as GroupField).groupFields[key].generalProperties.fieldApiName } -${ currentControlLength - 1 } `]
                    ) {
                      return searchableObject
                    }


                    return searchableObject?.filter((g: any) => {
                      // console.log(JSON.stringify(f));
                      // console.log(JSON.stringify(g));
                      if (typeof (g) == "object") {
                        const keys = Object.keys(g);

                        return keys.some((key) => {
                          // console.log(key);
                          return g[key].toLowerCase().includes(f);
                        })
                      } else {
                        return g.toLowerCase().includes(f)
                      }
                    })
                  }))
          }
          // this.searchableObject[`${(fieldData as GroupField).groupFields[key].generalProperties.fieldApiName} -${currentControlLength - 1} `] = searchableObject;
          // console.log(this.searchableObject);
        }
      }
    } else {
      control = this.fb.control('');


      //const control = this.fb.control('');


      this.getAFormArrayControl(fieldApiName).push(control);
      const currentControlLength = this.getAFormArrayControl(fieldApiName).controls.length;
      console.log(currentControlLength);
      if (currentControlLength > 1) {
        this.fieldAutoCompleteObject[`${fieldApiName}-${currentControlLength - 1}`] = control.valueChanges.pipe(startWith(""), map((f: any) => {
          console.log(f);
          if (typeof (f) === "string") {
            f = f.toLowerCase();
          }

          let searchableObject;

          let field = fieldData as FormFields;

          // if (field.generalProperties.controllingField && field.generalProperties.controllingField.length > 0) {
          //   for (const cField of field.generalProperties?.controllingField) {
          //     // first hide all controlled fields
// $#$          //     // /* alert(f + " " + field.generalProperties.fieldApiName); */
// $#$          //     // /* alert(leaveDependencyId); */
          //     // if (!leaveDependencyId) {

          //     //is the element matching the control field attribute more tha one
          //     let count = Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`)).length;
          //     // if (count > 1) {
          //     // get all controlled and controlling fields
          //     let controlledFields = Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`));
          //     let controllingFields = Array.from(document.querySelectorAll(`[controlledFieldsIdentifier *= "${this.joinAPropInEachObjectElementOfAnArray(field.generalProperties.controllingField, 'controlledFieldDependencyId', ' ')}"]`)).filter(
          //       (el: Element) => el.getAttribute('controlledFieldsIdentifier')?.includes(cField.controlledFieldDependencyId!)
          //     );
          //     //iterate to use the indexx
          //     controlledFields.forEach((cf: any, index) => {
          //       let fHere = controllingFields[index].getElementsByTagName('input')[0].value;
// $#$          //       /* alert(fHere); */

          //       (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[index] as HTMLElement)?.classList.add('d-none');
          //       if (fHere === cField.dependentFieldVisibilityTriggerValue) {
          //         // alert
          //         (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[index] as HTMLElement)?.classList.remove('d-none');
          //         (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[index] as HTMLElement).style.width = '100%';
          //       } else {

          //       }

          //     }
          //     )
          //     // } else {

          //     //   (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[0] as HTMLElement)?.classList.add('d-none');

          //     //   // then show the controlled field if the value matches the trigger value

          //     //   if (f === cField.dependentFieldVisibilityTriggerValue) {
          //     //     (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[0] as HTMLElement)?.classList.remove('d-none');
          //     //     (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[0] as HTMLElement).style.width = '100%';
          //     //   }
          //     // }
          //     // }
          //   }
          // }

          if (field.generalProperties.fieldType == "IndividualReferenceField" || field.generalProperties.fieldType == 'CodeableConceptField' || field.generalProperties.fieldType == "CodeField") {

            switch (field.generalProperties.fieldType) {
              case "IndividualReferenceField":
                searchableObject = (field as IndividualReferenceField).data || [];
                break;
              case "CodeableConceptField":
// $#$                //   /* alert(field.generalProperties.fieldType); */
                searchableObject = ((field as CodeableConceptField).data as codeableConceptDataType).coding || (field as CodeableConceptField).data || [];
                console.log("searchable object", searchableObject)
                break;
              case "CodeField":
                searchableObject = (field as CodeField).data || [];
                break;
              default:
                searchableObject = [];
                break;
            }



          }
          console.log(field.generalProperties)
          if (field.generalProperties.controllingField && field.generalProperties.controllingField.length > 0) {
            for (const cField of field.generalProperties?.controllingField) {
              // first hide all controlled fields
// $#$              // /* alert(f + " " + field.generalProperties.fieldApiName); */
// $#$              // /* alert(leaveDependencyId); */
              // if (!leaveDependencyId) {

              //is the element matching the control field attribute more tha one
              let count = Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`)).length;
              // if (count > 1) {
              // get all controlled and controlling fields
              let controlledFields = Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`));
              let controllingFields = Array.from(document.querySelectorAll(`[controlledFieldsIdentifier *= "${this.joinAPropInEachObjectElementOfAnArray(field.generalProperties.controllingField, 'controlledFieldDependencyId', ' ')}"]`)).filter(
                (el: Element) => el.getAttribute('controlledFieldsIdentifier')?.includes(cField.controlledFieldDependencyId!)
              );
              console.log(controllingFields, controlledFields);
              //iterate to use the indexx
              controlledFields.forEach((cf: any, index) => {
                let fHere = controllingFields[index].getElementsByTagName('input')[0].value;
                console.log(index);
                // console.log(Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[index],
                //   Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[index]);


                (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[index] as HTMLElement)?.classList.add('d-none');
                if (fHere === cField.dependentFieldVisibilityTriggerValue) {
                  // /* alert
                  (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[index] as HTMLElement)?.classList.remove('d-none');
                  (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[index] as HTMLElement).style.width = '100%';
                } else {

                }

              }
              )
              // } else {

              //   (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[0] as HTMLElement)?.classList.add('d-none');

              //   // then show the controlled field if the value matches the trigger value

              //   if (f === cField.dependentFieldVisibilityTriggerValue) {
              //     (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[0] as HTMLElement)?.classList.remove('d-none');
              //     (Array.from(document.querySelectorAll(`[dependency-id *= "${cField.controlledFieldDependencyId}"]`))[0] as HTMLElement).style.width = '100%';
              //   }
              // }

            }
          }
          if (!this.fieldsCompleteData[`${fieldApiName}-${currentControlLength - 1}`]) {
            this.fieldsCompleteData[`${fieldApiName}-${currentControlLength - 1}`] = searchableObject;
          }

          return searchableObject?.filter((g: any) => {
            if (typeof (g) == "object") {
              const keys = Object.keys(g);

              return keys.some((key) => {
                return g[key].toLowerCase().includes(f);
              })
            } else {
              return g.toLowerCase().includes(f)
            }
          })
        }))

      }
      // console.log(this.fieldAutoCompleteObject)

    }

  }
  @ViewChildren('input', { read: ElementRef }) allInputs!: QueryList<ElementRef>;

  fieldsCompleteData: any = {};

  // Track which fields have already had their autocomplete data loaded
  private autocompleteLoadedFields = new Set<string>();

  deleteFromAFormArray(fieldApiName: string, index: number) {
    const controlArray = this.getAFormArrayControl(fieldApiName);
    if (controlArray.length > 1) {
      controlArray.removeAt(index);
    } else {
      controlArray.setValue(['']);
    }
  }
  errorService = inject(ErrorService);
  closeAndReturn() {
    if (this.aForm.invalid) {
      this.errorService.openandCloseError('Please complete all required fields before submitting the form.');
      return;
    }
    if (this.formMetaData?.closeDialogOnSubmit && this.dialogRef) {
      this.dialogRef.close({
        values: this.aForm.value,
        formMetaData: this.formMetaData,
        formFields: this.formFields
      });
    }
    const deepClone = <T>(value: T): T => {
      // Best option in modern browsers/node (deep clone, no shared refs)
      if (typeof structuredClone === 'function') {
        return structuredClone(value);
      }

      // Fallback: deep clone plain objects/arrays/dates
      if (value === null || typeof value !== 'object') return value;
      if (value instanceof Date) return new Date(value.getTime()) as T;
      if (Array.isArray(value)) return value.map(deepClone) as T;

      const out: any = {};
      for (const [k, v] of Object.entries(value as any)) {
        out[k] = deepClone(v);
      }
      return out as T;
    };

    const toEmit = deepClone(this.aForm.value);

    if (this.resetOnSubmit) {
      this.aForm.reset();
    }
    this.formSubmitted.emit(toEmit);
    this.notif.success('Form submitted');


  }
  @ViewChildren('timeTrig') timeTriggs!: QueryList<HTMLElement>
  @ViewChildren('hsel') hourSelects!: QueryList<ElementRef>;
  @ViewChildren('msel') minuteSelects!: QueryList<ElementRef>;
  fromEvents(element: HTMLElement, events: string[]) {
    return merge(
      ...events.map(ev =>
        fromEvent(element, ev).pipe(map(e => ({ type: ev, event: e })))
      )
    );
  }


  resetAutocompleteObject(dataApiName: string) {

    // Prevent re-running if already loaded for this field
    // if (this.autocompleteLoadedFields.has(dataApiName)) {
    //   return;
    // }

    // // Check if autocomplete data exists for this field
    // if (this.fieldAutoCompleteObject && this.fieldAutoCompleteObject[dataApiName]) {
    //   this.fieldAutoCompleteObject[dataApiName] = of(this.fieldsCompleteData[dataApiName])

    //   // Mark this field as loaded to prevent re-execution
    //   this.autocompleteLoadedFields.add(dataApiName);

    //   console.log(`✅ Autocomplete data loaded for field: ${ dataApiName } `);
    // }
  }
  allInputsCurrentEvent = new BehaviorSubject<{ [key: string]: string }>({});

  shakeControls() {

    console.log("Form + controls now stable");


    // Setup focus handlers for all inputs to populate fieldsCompleteData
    this.allInputs.changes.pipe(map((list: any) => {
      return list.toArray()
    })).subscribe((list: any) => {
      list.forEach((inputElement: ElementRef<HTMLInputElement>) => {
// $#$        // /* alert("adding listener" ) */
        console.log(list);
        const el = inputElement.nativeElement;
// $#$        // /* alert(el.getAttribute('data-apiName') */)

        const uiEvents$ = this.fromEvents(el, [
          'focus',
          'blur',
          'input',
          'keydown',
          'mouseenter',
          'mouseleave'
        ]);
        //  this.allInputsCurrentEvent[el.getAttribute('data-apiName') || 'unknown'] = new BehaviorSubject<string>('init');

        uiEvents$.subscribe(({ type }) => {

          this.allInputsCurrentEvent.next({
            ...this.allInputsCurrentEvent.getValue(),
            [el.getAttribute('data-apiName') || 'unknown']: type
          });
          console.log(this.allInputsCurrentEvent.getValue());

        });


      })

    });

  }
  ngAfterViewInit() {
    // ngAfterViewInit() {
    Promise.resolve().then(() => {
      console.log("Form + controls now stable");
      this.allInputs.forEach((inputElement: ElementRef<HTMLInputElement>) => {
// $#$        // /* alert("adding listener" ) */
        const el = inputElement.nativeElement;
// $#$        // /* alert(el.getAttribute('data-apiName') */)

        const uiEvents$ = this.fromEvents(el, [
          'focus',
          'blur',
          'input',
          'keydown',
          'mouseenter',
          'mouseleave'
        ]);
        //  this.allInputsCurrentEvent[el.getAttribute('data-apiName') || 'unknown'] = new BehaviorSubject<string>('init');

        uiEvents$.subscribe(({ type }) => {
// $#$          // /* alert('Event fired:'+ type); */
          this.allInputsCurrentEvent.next({
            ...this.allInputsCurrentEvent.getValue(),
            [el.getAttribute('data-apiName') || 'unknown']: type
          });
        });


      })
      // }

      this.shakeControls();


    });
    if ((this.timeTriggs) && this.timeTriggs.length) {
      this.timeTriggs.forEach((e) => {
        //console.log(e.nativeElement as HTMLElement,);
        flatpickr(e, {
          enableTime: true,
          noCalendar: true,
          dateFormat: "H:i",
        })
      })
    }
    this.hourSelects.forEach((e: ElementRef, idx: number) => {
      const realHour = e.nativeElement.querySelector('.real-hour');
      const allEachHour: HTMLInputElement[] = e.nativeElement.querySelectorAll('.each-hour');

      const incButton = e.nativeElement.querySelector('.inc');
      this.realHourScroll[idx] = 0
      const decButton = e.nativeElement.querySelector('.dec');

      incButton.onclick = () => {
        const currentSeenHourIndex = Array.from(allEachHour).findIndex((e: HTMLInputElement) => {
          const parentRect = realHour.getBoundingClientRect();
          const childRect = e.getBoundingClientRect();

          return (
            childRect.top >= parentRect.top &&
            childRect.left >= parentRect.left &&
            childRect.bottom <= parentRect.bottom &&
            childRect.right <= parentRect.right
          );
        });

        if (currentSeenHourIndex < allEachHour.length - 1) {
// $#$          ///* alert(allEachHour.length + " " + currentSeenHourIndex); */
          this.realHourScroll[idx] += 40
// $#$          // /* alert(this.realHourScroll); */

          realHour.scroll(0, this.realHourScroll[idx]);
        }





      }


      decButton.onclick = () => {
        const currentSeenHourIndex = Array.from(allEachHour).findIndex((e: HTMLInputElement) => {
          const parentRect = realHour.getBoundingClientRect();
          const childRect = e.getBoundingClientRect();

          return (
            childRect.top >= parentRect.top &&
            childRect.left >= parentRect.left &&
            childRect.bottom <= parentRect.bottom &&
            childRect.right <= parentRect.right
          );
        });

        if (currentSeenHourIndex > 0) {
          this.realHourScroll[idx] -= 40
// $#$          // /* alert(this.realHourScroll); */

          realHour.scroll(0, this.realHourScroll[idx]);
        }





      }
    })

    this.minuteSelects.forEach((e: ElementRef) => {

    })

    // Attach focus handlers to all autocomplete inputs to restore full adata
    // this.autocompleteInputs.forEach((inputRef: ElementRef) => {
    //   const inputElement = inputRef.nativeElement as HTMLInputElement;
    //   const fieldApiName = inputElement.getAttribute('data-field-api-name');

    //   if (!fieldApiName) return;

    //   // Find the field definition to check if it has data and is not CodeableConceptFieldFromBackEnd
    //   const fieldData = this.formFields.find((f: FormFields) =>
    //     f.generalProperties.fieldApiName === fieldApiName
    //   );

    //   if (!fieldData) return;

    //   // Skip if it's a CodeableConceptFieldFromBackEnd (those are handled separately)
    //   if (fieldData.generalProperties.fieldType === 'CodeableConceptFieldFromBackEnd') {
    //     return;
    //   }

    //   // Check if this field has data in searchableObject
    //   const hasData = this.searchableObject[fieldApiName] &&
    //     Array.isArray(this.searchableObject[fieldApiName]) &&
    //     this.searchableObject[fieldApiName].length > 0;

    //   if (!hasData) return;

    //   // Attach focus handler to restore full unfiltered data
    //   inputElement.addEventListener('focus', () => {
    //     const control = this.aForm.get(fieldApiName) as FormControl;
    //     if (control) {
    //       // Trigger valueChanges with empty string to show all options
    //       control.setValue(control.value || '', { emitEvent: true });
    //     }
    //   });
    // });
    try {
      this.ready.emit();
    } catch (e) {
      // ignore
    }
  }
  onPhotosUploaded(files: any[], fieldApiName: string) {
    console.log('Photos uploaded for field', fieldApiName, files);
    const control = this.aForm.get(fieldApiName) as FormControl;
    if (control) {
      let existingValues = control.value// ?? [];
      if ((existingValues && !Array.isArray(existingValues)) || !existingValues) {
        // existingValues = [existingValues];
        control.setValue(files[0]);
      } else {
        console.log(existingValues);
        const newValues = files;
        control.setValue([...existingValues, ...newValues]);
      }
    }
    // Notify parent that the dynamic form component has finished initialising

  }
  private overlay = inject(Overlay);
  private menuOpenTimer?: ReturnType<typeof setTimeout>;
  private menuCloseTimer?: ReturnType<typeof setTimeout>;
  public lastHoveredTrigger?: MatMenuTrigger;
  toUseUrl = `https://elikita-server.daalitech.com`;
  triggerForMatMenu(trigger?: MatMenuTrigger, cdRef?: string): void {
// $#$    // /* alert(cdRef); */
    this.toUseUrl = `${this.backendEndPoint}/${cdRef}`;
    if (!trigger) return;
    this.lastHoveredTrigger = trigger;
    clearTimeout(this.menuCloseTimer);
    clearTimeout(this.menuOpenTimer);

    this.menuOpenTimer = setTimeout(() => {
      trigger.openMenu();
      //can i  make the panel scroll itself if its going out of the view port


      setTimeout(() => {
        const overlayRef = (trigger as any)?._overlayRef as OverlayRef | undefined;
        if (!overlayRef) return;

        const originEl = (trigger as any)?._elementRef?.nativeElement as HTMLElement | undefined;
        const top = (originEl?.getBoundingClientRect().top ?? 0) + window.scrollY;

        overlayRef.updatePositionStrategy(
          this.overlay.position().global().left('0px').top(`${Math.max(top, 0)}px`)
        );
        this.ensureOverlayWithinViewport(overlayRef);
      });
    }, 120);
  }

  private ensureOverlayWithinViewport(overlayRef: OverlayRef) {
    if (!overlayRef?.overlayElement) return;
    requestAnimationFrame(() => {
      const rect = overlayRef.overlayElement.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const padding = 12;

      if (rect.bottom > viewportHeight) {
        const delta = rect.bottom - viewportHeight + padding;
        window.scrollBy({ top: delta, behavior: 'smooth' });
      } else if (rect.top < 0) {
        const delta = rect.top - padding;
        window.scrollBy({ top: delta, behavior: 'smooth' });
      }
    });
  }

  closeMenu(trigger?: MatMenuTrigger): void {
    clearTimeout(this.menuOpenTimer);
    clearTimeout(this.menuCloseTimer);

    this.menuCloseTimer = setTimeout(() => {
      if (!trigger || trigger !== this.lastHoveredTrigger) return;
      trigger.closeMenu();
      this.lastHoveredTrigger = undefined;
    }, 150);
  }

  cancelPendingMenuClose(): void {
    clearTimeout(this.menuCloseTimer);
  }
  requiredFieldLabels: string[] = [];

  private recomputeRequiredFieldLabels(): void {
    this.requiredFieldLabels = this.extractRequiredFieldLabels(this.formFields ?? []);
  }

  private extractRequiredFieldLabels(fields: FormFields[]): string[] {
    const labels = new Set<string>();
    const processField = (field: FormFields) => {
      if (this.fieldHasRequiredValidation(field)) {
        labels.add(this.getFieldLabel(field));
      }
      if (field.generalProperties.isGroup && 'groupFields' in field) {
        const group = field as GroupField;
        Object.values(group.groupFields).forEach(processField);
      }
    };
    fields.forEach(processField);
    return Array.from(labels);
  }

  private fieldHasRequiredValidation(field: FormFields): boolean {
    return (field.generalProperties.validations || []).some(validation => this.isRequiredValidation(validation));
  }

  private isRequiredValidation(validation: any): boolean {
    const name = String(validation?.name ?? validation?.type ?? '').toLowerCase();
    return name.includes('required');
  }

  private getFieldLabel(field: FormFields): string {
    return field.generalProperties.fieldLabel || field.generalProperties.fieldName || field.generalProperties.fieldApiName;
  }

  joinAPropInEachObjectElementOfAnArray(arr: Record<string, any>[] | undefined, propName: string, separator: string = ', '): string {
    if (arr === undefined) {
      return '';
    }
    return arr?.map(item => item[propName]).join(separator) ?? '';
  }
}



